/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DotMenu from 'app/components/molecules/DotMenu/DotMenu';
import Loader from 'app/components/atoms/Loader/Loader';
import history from 'store/History';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { closeSidebar } from 'store/actions/sidebar/sidebarActions';
import { mediaBreakpoints } from 'app/themes/breakpoints';
import { setActions, setSubTitle } from 'store/actions/sidebar/sidebarActions';
import EventTypeAbout from 'app/containers/Stream/Events/EventTypes/EventTypeAbout';

import { loadEventTypeDetails } from 'store/actions/stream/eventsActions';
import { shrinkSidebar, expandSidebar } from 'store/actions/sidebar/sidebarActions';
import { baseRoutes } from 'app/config/routesConfig';

const dataType = 'eventtype';

class EventTypeSidebar extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        details: PropTypes.object,
        title: PropTypes.string,
        isOpen: PropTypes.bool,
        // from redux
        isLoading: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.initData();
    }

    componentDidUpdate(prevProps) {
        this.initData();
    }

    @bind
    setActions(expanded) {
        this.props.setActions(this.dotMenu(expanded));
    }

    @bind
    setSubTitle(name) {
        this.props.setSubTitle(name);
    }

    initData() {
        const { id, isOpen, isLoading, details, expanded } = this.props;
        if (!isOpen) {
            return;
        }
        this.setActions(expanded);
        if (isLoading) {
            return;
        }
        const loaded = details || {};
        if (loaded.id === id) {
            this.setSubTitle(details.name);
            return;
        }
        this.props.loadEventTypeDetails(id);
    }

    @bind
    onDotMenuClick(title) {
        const { expanded, expandSidebar, shrinkSidebar, id } = this.props;
        if (['Collapse', 'Expand'].includes(title)) {
            const action = expanded ? shrinkSidebar : expandSidebar;
            action();
        }
        if (title === 'Go to details') {
            this.goToDetails();
        }
        if (title === 'Attributes') {
            history.push(`${baseRoutes[dataType]}/${id}/attributes`);
        }
    }

    goToDetails() {
        const { windowWidth, id, shrinkSidebar, closeSidebar } = this.props;
        history.push(`${baseRoutes[dataType]}/${id}`);
        if (!windowWidth < mediaBreakpoints.sm) {
            shrinkSidebar();
        } else {
            closeSidebar();
        }
    }

    @bind
    @memoize()
    dotMenu(expanded) {
        return (
            <DotMenu
                key={13}
                onItemClick={this.onDotMenuClick}
                items={[
                    { name: 'Attributes', icon: 'classification-editor', iconType: 'af' },
                    { name: 'divider' },
                    { name: expanded ? 'Collapse' : 'Expand', icon: expanded ? 'arrow-collapse' : 'open-in-new' },
                    { name: 'Go to details', icon: 'login-variant' },
                ].filter(Boolean)}
            />
        );
    }

    render() {
        const { isLoading, title, details, isOpen, reloadList } = this.props;
        const isLoaded = details;
        return (
            isOpen && (
                <>
                    {isLoading && <Loader absolute backdrop />}
                    {isLoaded && title === 'About' && <EventTypeAbout isSidebar details={details} reloadList={reloadList} />}
                </>
            )
        );
    }
}

export default connect(
    (state, ownProps) => ({
        details: state.stream.events.typeData.data,
        isLoading: state.stream.events.typeData.isLoading,
        isOpen: state.sidebar.isOpen,
        expanded: state.sidebar.expanded,
        windowWidth: state.global.window.width,
    }),
    { shrinkSidebar, expandSidebar, loadEventTypeDetails, closeSidebar, setActions, setSubTitle }
)(EventTypeSidebar);
